/*
  Free Access form component - migrated from jwt-bch-frontend
*/

import React, { useState } from 'react'
import { Form, Button, Alert } from 'react-bootstrap'
import Captcha from './captcha'
import NOTIFICATION from '../lib/notification'

const SERVER = process.env.REACT_APP_AUTHSERVER || process.env.AUTHSERVER || 'http://localhost:5001'
const Notification = new NOTIFICATION()

function FreeAccessForm () {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [formMessage, setFormMessage] = useState('')
  const [message, setMessage] = useState('')
  const [captchaIsValid, setCaptchaIsValid] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [showError, setShowError] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const validateEmail = (email) => {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage('')

    try {
      // Validate form
      if (!email || email === '') {
        throw new Error('Email cannot be empty')
      }
      if (!validateEmail(email)) {
        throw new Error('Email must be in valid format')
      }
      if (!formMessage || formMessage === '') {
        throw new Error('Message cannot be empty')
      }
      if (!captchaIsValid) {
        throw new Error('Captcha is invalid')
      }

      setIsSubmitting(true)

      // Similar to contact form, submit to server
      const obj = {
        name,
        email,
        formMessage,
        subject: 'Free Access Request from FullStack.cash',
        emailList: ['test@bchtest.net'],
        payloadTitle: 'Free Access Request'
      }

      const resp = await fetch(`${SERVER}/contact/email`, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify({ obj }),
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const data = await resp.json()

      if (data.success) {
        Notification.notify('Success!!', 'Thank you!', 'success')
        setShowSuccess(true)
        setShowError(false)
        // Reset form
        setName('')
        setEmail('')
        setFormMessage('')
        setCaptchaIsValid(false)
      } else {
        Notification.notify('Error', 'An error occurred.', 'danger')
        setShowError(true)
        setShowSuccess(false)
      }
    } catch (err) {
      Notification.notify('Error', err.message, 'danger')
      setMessage(err.message)
      setShowError(true)
      setShowSuccess(false)
    } finally {
      setIsSubmitting(false)
    }
  }

  if (showSuccess) {
    return (
      <Alert variant='success'>
        <h4><strong>Thank you!</strong></h4>
        <p>
          Your free access request has been submitted. We will review it and get back to you soon.
        </p>
      </Alert>
    )
  }

  if (showError) {
    return (
      <Alert variant='danger'>
        <h4><strong>Error!</strong></h4>
        <p>
          An error occurred. Try reloading this page and trying again. If it
          continues, please try again later.
        </p>
        <Button
          variant='outline-danger' onClick={() => {
            setShowError(false)
            setShowSuccess(false)
          }}
        >
          Try Again
        </Button>
      </Alert>
    )
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className='mb-3'>
        <Form.Label><strong>Name:</strong></Form.Label>
        <Form.Control
          type='text'
          name='name'
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='John Doe'
        />
      </Form.Group>

      <Form.Group className='mb-3'>
        <Form.Label><strong>Email:</strong></Form.Label>
        <Form.Control
          type='email'
          name='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder='your@email.com'
        />
      </Form.Group>

      <Form.Group className='mb-3'>
        <Form.Label><strong>Message:</strong> (Describe your project)</Form.Label>
        <Form.Control
          as='textarea'
          rows={5}
          name='formMessage'
          value={formMessage}
          onChange={(e) => setFormMessage(e.target.value)}
          placeholder='Describe your Bitcoin Cash project and how it would help the community...'
        />
      </Form.Group>

      {message && (
        <Alert variant='danger'>{message}</Alert>
      )}

      <Captcha callback={(err, isValid) => {
        if (err) return
        setCaptchaIsValid(isValid)
      }}
      />

      <Button
        type='submit'
        variant='primary'
        disabled={isSubmitting || !captchaIsValid}
        className='mt-3'
      >
        {isSubmitting ? 'Submitting...' : 'Submit Request'}
      </Button>
    </Form>
  )
}

export default FreeAccessForm
